import { useSelector } from 'hooks/store';

export const useUserLoggedIn = () => {
    const { isComplete, isAuthenticated } = useSelector((state) => state.auth);

    return Boolean(isAuthenticated && isComplete);
};
